import { useParams, useSearchParams, useNavigate } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";
import { useCallback, useMemo, useRef, useState } from "react";
import { ActivarEq, FinalizarEq, NoFinalizarEq } from "../EqInOt/FinalizarEq";
import { Alertassw } from "../Alertas/Alertassw";
import { useOtMovimientos } from "../../hooks/useOtMovimientos";
import { useVisitaVigente } from "../../hooks/useVisitaVigente";
import { Modalcarga } from "../Modales/Modalcarga";
import Cabecera from "../Ot/Cabecera";
import { ContadoresOt } from "../Ot/IndicadoresOt";
import ModalController from "./ModalController";
import HojasTrabajo from "../Aprobar/HojasTrabajo";
import ToolbarActionsResponsive from "./ToolbarActionsResponsive";
import TableEquiposCompact from "./TableEquiposCompact";
import { Spinner } from "react-bootstrap";
import DateProgram from "../Ot/DateProgram";
import { AprobarSeleccion, DesaprobarSeleccion } from "../EqInOt/AprobarSelect";
import useOtLogic from "./useOtLogic";
import ModalRegistrarMovimiento from "../Finanzas/ModalRegistrarMovimiento";
import { getBolsilloMio } from "../../api/finanzas";
import ModalConfirmarEntrega from "../Prestamos/ConfrimarEntrega";
import { Modal } from "react-bootstrap";
import NuevaSalida from "../SalidaEntradaPatrones/NuevaSalida";
import DetalleMovimiento from "../SalidaEntradaPatrones/DetalleMovimiento";
import AgregarEquiposOt from "../Ot/AgregarEquiposOt";
import ModalHojasTrabajo from "./ModalHojasTrabajo";
import ModalReprogramar from "../Programaciones/ModalReprogramar";
import { Alert, Button } from "react-bootstrap";
import ModalConfirmarAccionPareja from "../Ot/ModalConfirmarAccionPareja";
import useAccionParejaOt from "../../hooks/useAccionParejaOt";


export default function OtSelectMain(){
  const [searchParams] = useSearchParams();
  const { id } = useParams();
  const navigate = useNavigate();
  const task = searchParams.get('task');
  const { ots, setOt, equiposOtIni, setEquiposOtIni, sedes, setSedes, modalCharge, setModalCharge, toggleRefresh, dataProgramacion, error } = useOtLogic({ id, searchParams });

  const [mostrarModalConfirmar, setMostrarModalConfirmar] = useState(false);
  const [mostrarModalSalidaEntrada, setMostrarModalSalidaEntrada] = useState(false);
  const [mostrarModalDetalle, setMostrarModalDetalle] = useState(false);
  const [movimientoDetalleData, setMovimientoDetalleData] = useState(null);

  // Movimientos de patrones — cacheados por RQ, se invalidan con toggleRefresh
  const { data: movData } = useOtMovimientos(ots?._id);
  const movimientosActivos = movData?.activos || [];
  const patronIdsActivos = movData?.patronIds || new Set();

  // Visita vigente — se inicia en paralelo al fetch principal (comparten el mismo id)
  const { data: visitaVigente } = useVisitaVigente(id);

  const userData = useAuth();
  const result = userData.userData;

  // UI states
  const [estadomodal, setEstadomodal] = useState(false);
  const [accion, setAccion] = useState({ tarea:'', titulo:'' });
  const [equipoinfo, setEquipoinfo] = useState(null);
  const [sedeSeleted, setSedeSeleted] = useState(null);
  const [sitioSeleted, setSitioSeleted] = useState(null);
  const [optionAproved, setOptionAproved] = useState(null);
  const [onGastoModal, setOnGastoModal]=useState(false)
  const [bolsilloMio, setBolsilloMio] = useState(null)

  // Caché equipos cliente para modal de adicionar
  const [historialeq, setHistorialEq] = useState(null);
  const [showModalAddEquipos, setShowModalAddEquipos] = useState(false);

  // Modal de Hojas de Trabajo
  const [showModalHT, setShowModalHT] = useState(false);
  const [cacheHT, setCacheHT] = useState(null);

  const [showReprogramar, setShowReprogramar] = useState(false);

  // Hook reutilizable para envolver acciones (Activar, Aplazar, Desaprobar) con
  // consulta previa de pareja. Cancelar tiene su propio flujo con motivo obligatorio;
  // Procesar NO se envuelve por diseño (individual).
  // Este hook es compartido con Otselect.js — misma UX en ambas rutas.
  const { envolverConPareja, modalAccionParejaProps } = useAccionParejaOt({
    otId: ots?._id,
    equiposOtIni,
  });


  // selection ref to avoid re-renders
  const equiSelectRef = useRef([]);
  const [fakeState, setFakeState] = useState(false); // to force small re-renders for checkbox UI
  const [selectAll, setSelectAll] = useState(false);

  // Filters with useMemo
  const EqSitioFilter = useMemo(()=>{
    if(!sitioSeleted) return equiposOtIni;
    return sitioSeleted === 'Sitio' ? equiposOtIni.filter(e=>!e.fechaIngreso) : equiposOtIni.filter(e=>e.fechaIngreso);
  },[sitioSeleted, equiposOtIni]);

  const EqSedeFilter = useMemo(()=>{
    if(!sedeSeleted) return EqSitioFilter;
    return EqSitioFilter.filter(item=> item?.equipo?.sedeClient?._id === sedeSeleted);
  },[sedeSeleted, EqSitioFilter]);

  // Actions handlers
  const handleFinalize = useCallback(async (eq)=>{
    // Procesar (estado 'Procesado') — acción INDIVIDUAL por diseño (spec: no se
    // envuelve en el flujo de pareja; cada equipo se procesa por sí mismo).
    setModalCharge(true);
    const updated = await FinalizarEq(eq._id, ots?.numeroOrden, ots?.visitas, setModalCharge, result);
    if(updated) toggleRefresh();
  },[ots, result, toggleRefresh]);

  // Ejecutor "puro" de Activar — usado tanto individual como envuelto.
  const ejecutarActivar = useCallback(async (eq)=>{
    setModalCharge(true);
    const updated = await ActivarEq(eq._id, ots?.numeroOrden, ots?.visitas, setModalCharge, result, ots, eq, ()=>({}));
    if(updated) toggleRefresh();
  },[ots, result, toggleRefresh]);

  const ejecutarNoFinalize = useCallback(async (eq)=>{
    setModalCharge(true);
    const updated = await NoFinalizarEq(eq._id, setModalCharge, task);
    if(updated) toggleRefresh();
  },[task, toggleRefresh]);

  // Handlers envueltos con consulta de pareja (spec equipos-dependientes-sincronizacion-cancelacion).
  const handleActivate = useMemo(
    () => envolverConPareja({ handler: ejecutarActivar, accionLabel: 'activación', excluirEstados: [] }),
    [envolverConPareja, ejecutarActivar]
  );

  const handleNoFinalize = useMemo(
    () => envolverConPareja({ handler: ejecutarNoFinalize, accionLabel: 'aplazamiento' }),
    [envolverConPareja, ejecutarNoFinalize]
  );

  const handleEdit = (eq)=>{ 
    setEquipoinfo(eq); setAccion({tarea:'Editar', titulo: eq.equipo?.item?.nombre}); setEstadomodal(true);} 
  const handleObserv = (eq)=>{ setEquipoinfo(eq); setAccion({tarea:'Observacion', titulo: eq.equipo?.item?.nombre}); setEstadomodal(true);} 
  const handleCancel = (eq)=>{ setEquipoinfo(eq); setAccion({tarea:'Cancelar', titulo: eq.equipo?.item?.nombre}); setEstadomodal(true);} 
  const handleAddEquiposProgramacion = ()=>{ setShowModalAddEquipos(true); }
  const handleOpenHT = (title)=>{ 
    if (title === 'Hojas de Trabajo') {
      setShowModalHT(true);
    } else {
      setAccion({ tarea: title, titulo: title });
      setEstadomodal(true);
    }
  }
  const handleCreateHT = ()=>{ 
    setAccion({
      tarea:'Hoja de Trabajo', 
      titulo: ots?.numeroOrden + '-' + ots?.visitas}); 
      setEstadomodal(true); 
    }
  const handleExport = ()=> DateProgram(ots);

  const aprovarAllCheck = (e)=>{
    const checked = e.target.checked;
    setSelectAll(checked);
    if(checked){
      // seleccionar todos
      equiSelectRef.current = [...EqSedeFilter];
    }else{
      equiSelectRef.current = [];
    }
    setFakeState(s=>!s);
  }

  const aprovarOneToggle = (eq)=>{
    const exists = equiSelectRef.current.some(o=>o._id===eq._id);
    if(exists){ equiSelectRef.current = equiSelectRef.current.filter(o=>o._id!==eq._id);} else { equiSelectRef.current.push(eq);} 
    setSelectAll(false);
    setFakeState(s=>!s);
  }

  const handleAprobarSeleccion = useCallback(async () => {
    await AprobarSeleccion(equiSelectRef.current, result, ots?.numeroOrden, ots?.visitas, setModalCharge, toggleRefresh)
    equiSelectRef.current = []
    setSelectAll(false)
    setFakeState(s => !s)
  }, [result, ots, toggleRefresh])

  const ejecutarDesaprobar = useCallback(async (eq) => {
    await DesaprobarSeleccion([eq], setModalCharge, toggleRefresh)
  }, [toggleRefresh])

  const handleDesaprobar = useMemo(
    () => envolverConPareja({ handler: ejecutarDesaprobar, accionLabel: 'desaprobación' }),
    [envolverConPareja, ejecutarDesaprobar]
  );

  const onGasto = async () => {
    // Carga lazy: solo consulta el bolsillo la primera vez
    let bolsillo = bolsilloMio;
    if (!bolsillo) {
      try {
        const resp = await getBolsilloMio();
        bolsillo = resp?.data?.data?.bolsillo;
        if (!bolsillo) {
          Alertassw('warning', 'Sin bolsillo', 'No tienes un bolsillo asignado. Contacta al administrador.');
          return;
        }
        setBolsilloMio(bolsillo);
      } catch {
        Alertassw('error', 'Error', 'No se pudo cargar el bolsillo');
        return;
      }
    }
    setOnGastoModal(true);
  }

  const cargarOt = async () => {
    setMostrarModalConfirmar(false); 
  }

  const handleAbrirSalidaPatrones = () => {
    if (!ots?._id) return;
    if (movimientosActivos.length > 0) {
      Alertassw('toast', 'Movimiento Activo', `Grupo ${movimientosActivos[0].groupConsecutive} — abriendo detalle...`);
      setMovimientoDetalleData(movimientosActivos[0]);
      setMostrarModalDetalle(true);
    } else {
      setMostrarModalSalidaEntrada(true);
    }
  }
    
  // render
  if (error) {
    return (
      <div className="container mt-4">
        <div className="alert alert-danger">
          <i className="bi bi-exclamation-triangle me-2"/>
          <strong>Error:</strong> {error}
        </div>
      </div>
    );
  }
  
  if (modalCharge) return <Modalcarga estadoIn={modalCharge} cambiarestadoIn={setModalCharge}><Spinner/></Modalcarga>

  return (
    <div className="container py-3">
    <ModalConfirmarEntrega
      show={mostrarModalConfirmar}
      onHide={() => setMostrarModalConfirmar(false)}
      otId={ots?._id}
      onConfirmado={() => {
        // Recargar datos de la OT o mostrar mensaje
        cargarOt();
      }}
    />

    {/* Modal Detalle de Movimiento */}
    <Modal
      show={mostrarModalDetalle}
      onHide={() => {
        setMostrarModalDetalle(false);
        setMovimientoDetalleData(null);
      }}
      size="xl"
      centered
      scrollable
      style={{ maxHeight: '90vh' }}
    >
      <Modal.Body style={{ padding: 0 }}>
        {movimientoDetalleData && (
          <DetalleMovimiento
            groupConsecutive={movimientoDetalleData.groupConsecutive}
            movimientoId={movimientoDetalleData._id}
            onBack={() => {
              setMostrarModalDetalle(false);
              setMovimientoDetalleData(null);
            }}
            onRefresh={toggleRefresh}
          />
        )}
      </Modal.Body>
    </Modal>

    {/* Modal Salida de Patrones */}
    <Modal
      show={mostrarModalSalidaEntrada}
      onHide={() => setMostrarModalSalidaEntrada(false)}
      size="xl"
      centered
      scrollable
    >
      <Modal.Header closeButton className="bg-primary text-white">
        <Modal.Title>📦 Registrar Salida de Patrones</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ maxHeight: '75vh', overflowY: 'auto' }}>
        <NuevaSalida
          onBack={() => setMostrarModalSalidaEntrada(false)}
          onSuccess={() => {
            setMostrarModalSalidaEntrada(false);
            toggleRefresh();
          }}
          otDefault={ots ? {
            _id: ots._id,
            numeroOrden: ots.numeroOrden || '',
            cliente: dataProgramacion?.cliente?.nombre || '',
            ciudad: dataProgramacion?.cliente?.ciudad || ''
          } : null}
          equiposOt={EqSedeFilter}
        />
      </Modal.Body>
    </Modal>
      {ots && <Cabecera ots={dataProgramacion} selectSede={setSedeSeleted} sedeSeleted={sedeSeleted} setSitioSeleted={setSitioSeleted} refresh={false} setSedes={setSedes} />}
      <ContadoresOt ots={dataProgramacion} />
      <Modalcarga estadoIn={modalCharge} cambiarestadoIn={setModalCharge}><Spinner/></Modalcarga>
      <ModalController accion={accion} estadomodal={estadomodal} setEstadomodal={setEstadomodal} equipoinfo={equipoinfo} ots={ots} programData={dataProgramacion} handlers={{ toggleRefresh }} propsExtra={{ refreshFlag: null, setEquiposOtIni, refresh: null, setRefresh: toggleRefresh, sitioSeleted, EqSedeFilter, sedeSeleted, sedes, SetModalcharge: setModalCharge }} />
      <br/>
      <ToolbarActionsResponsive 
        task={task} 
        onCreateHT={handleCreateHT} 
        onAprobar={handleAprobarSeleccion}
        onAddItems={handleAddEquiposProgramacion} 
        onOpenHT={handleOpenHT} 
        onExport={handleExport} 
        onGasto={onGasto} 
        onConfirmarPrestamo={() => setMostrarModalConfirmar(true)} 
        onSalidaEntrega={handleAbrirSalidaPatrones}
        equiposSeleccionados={equiSelectRef.current.length}
      />
      
      {onGastoModal && bolsilloMio && (
        <ModalRegistrarMovimiento
          show={onGastoModal}
          onClose={() => setOnGastoModal(false)}
          onSuccess={() => setOnGastoModal(false)}
          bolsillo={bolsilloMio}
          otDefault={ots?._id ? {
            _id: ots._id,
            numeroOrden: ots.numeroOrden,
            cliente: dataProgramacion?.clientInformation || null
          } : null}
        />
      )}
      {task==='revisar' && (
        <div className="d-flex align-items-center gap-2 mb-2">
          <button className="btn btn-outline-primary" onClick={()=>setOptionAproved()}>Individual</button>
          <button className="btn btn-outline-primary" onClick={()=>setOptionAproved('Htrabajo')}>H. Trabajo</button>
        </div>
      )}

      {task === 'finalizar' && visitaVigente === null && (
        <Alert variant="warning" className="d-flex align-items-center justify-content-between mb-2">
          <span><i className="bi bi-calendar-x me-2"/>No hay visita vigente para esta programación. No se pueden procesar equipos hasta reprogramar.</span>
          <Button size="sm" variant="warning" onClick={() => setShowReprogramar(true)}>Reprogramar</Button>
        </Alert>
      )}

      <div className="card-body">
          <TableEquiposCompact 
            equipos={EqSedeFilter} 
            task={task} 
            currentUser={result}
            onEdit={handleEdit} 
            onCancel={handleCancel} 
            onObserv={handleObserv} 
            onFinalize={handleFinalize} 
            onActivate={handleActivate} 
            onNoFinalize={handleNoFinalize} 
            onAprovarOneToggle={aprovarOneToggle}
            equiSelectRef={equiSelectRef} 
            selectAll={selectAll} 
            onSelectAllChange={aprovarAllCheck}
            onDesaprovar={handleDesaprobar}
            patronIdsActivos={patronIdsActivos}
            hayVisitaVigente={visitaVigente !== null}
          />
        </div>

      {optionAproved==='Htrabajo' && <HojasTrabajo Orden={ots?.numeroOrden} SetModalcharge={setModalCharge} setRefresh={toggleRefresh} refresh={null} />}

      <Modal show={showModalAddEquipos} onHide={() => setShowModalAddEquipos(false)} size="xl" centered scrollable>
        <Modal.Header closeButton>
          <Modal.Title>
            <i className="bi bi-plus-circle me-2" />
            Adicionar Equipos — OT {ots?.numeroOrden}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <AgregarEquiposOt
            ot={dataProgramacion}
            setEstadoModal={() => setShowModalAddEquipos(false)}
            setRefresh={toggleRefresh}
            sedes={sedes}
            sedeSeleted={sedeSeleted}
            historialeq={historialeq}
            setHistorialEq={setHistorialEq}
          />
        </Modal.Body>
      </Modal>

      {/* Modal de Hojas de Trabajo */}
      <ModalHojasTrabajo
        show={showModalHT}
        onHide={() => setShowModalHT(false)}
        numeroOrden={ots?.numeroOrden}
        cache={cacheHT}
        setCache={setCacheHT}
        onRefresh={toggleRefresh}
      />

      {/* Modal Reprogramar visita */}
      <ModalReprogramar
        show={showReprogramar}
        onClose={() => setShowReprogramar(false)}
        onSuccess={() => { setShowReprogramar(false); toggleRefresh(); }}
        entidad="programacion"
        idEntidad={dataProgramacion?._id}
      />

      {/* Modal genérico: consulta al usuario si una acción sobre un equipo con
          pareja (padre/hijos) también debe aplicarse a la pareja.
          Spec items-adicionales-equipo-dependiente / sincronizacion-cancelacion. */}
      {modalAccionParejaProps.show && (
        <ModalConfirmarAccionPareja {...modalAccionParejaProps} />
      )}
    </div>
  );
};

